const ANIMALKINGDOMLANDS = [
    {
        name: 'Africa',
        rides: [
            {
                name: 'Festival of the Lion King',
                count: 0,
            },
            {
                name: 'Gorilla Falls Exploration Trail',
                count: 0,
            },
            {
                name: 'Kilimanjaro Safaris',
                count: 0,
            },
        ]
    },
    
    {
        name: 'Asia',
        rides: [
            {
                name: 'Expedition Everest - Legend of the Forbidden Mountain',
                count: 0,
            },
            {
                name: 'Kali River Rapids',
                count: 0,
            },
            {
                name: 'Maharajah Jungle Trek',
                count: 0,
            }
        ]
    },

    {
        name: 'DinoLand U.S.A',
        rides: [
            {
                name: 'DINOSAUR',
                count: 0,
            },
            {
                name: 'Finding Nemo: The Big Blue... and Beyond!',
                count: 0,
            },
            {
                name: 'The Boneyard',
                count: 0,
            },
            {
                name: 'TriceraTop Spin',
                count: 0,
            },
        ]
    },
    {
        name: 'Discovery Island',
        rides: [
            {
                name: "It's Tough to Be a Bug!",
                count: 0,
            },
            {
                name: 'Meet Favorite Disney Pals at Adventurers Outpost',
                count:0,
            }
        ]
    },

    {
        name: 'Pandora - The World of Avatar',
        rides: [
            {
                name: 'Avatar Flight of Passage',
                count: 0,
            },
            {
                name: "Na'vi River Journey",
                count: 0,
            },
            {
                name: "Valley of Mo'ara",
                count: 0,
            }
        ]
    },

    {
        name: "Rafiki's Planet Watch",
        rides: [
            {
                name: "Affection Section",
                count: 0,
            },
            {
                name: 'Conservation Station',
                count: 0,
            },
            {
                name: 'Habitat Habit!',
                count: 0,
            }
        ]
    }
]

export default ANIMALKINGDOMLANDS;